import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Group, Text } from '@mantine/core'
import { size } from 'lodash'
import React, { ReactElement } from 'react'

import useFieldValue from '../../../../../../1stlog-ui/src/components/Field/useFieldValue'
import {
  getNotificationTriggerLabels,
  TNotificationTrigger,
} from '../../../../../../1stlog-ui/src/constants/notificationTriggers'

type NotificationProps = {}

export const Notification = (props: NotificationProps): ReactElement => {
  const {} = props

  const trigger = useFieldValue<TNotificationTrigger>('trigger')
  const isEnabled = useFieldValue<boolean>('isEnabled')
  const labels = getNotificationTriggerLabels()
  const types = useFieldValue<any>('types')
  const isEmail = size(types) === 1 && types[0] === 'email'

  if (!isEnabled) {
    return <></>
  }

  return (
    <>
      <div>
        <Group>
          <FontAwesomeIcon icon={faCheck} />
          <Text>
            {labels[trigger]}
            {isEmail ? ` (${i18n.t('via_email', 'per E-Mail')})` : ''}
          </Text>
        </Group>
      </div>
    </>
  )
}
